import {
  Dropdown,
  Autocomplete,
  Field as FieldDrop,
  Item,
  Menu,
} from "@zendeskgarden/react-dropdowns";
import {
  Field,
  Field as ToggleField,
  Label,
  MediaInput,
  Toggle
} from "@zendeskgarden/react-forms";
import { Col, Row } from "@zendeskgarden/react-grid";
import { ThemeProvider } from "@zendeskgarden/react-theming";
// import { Dots } from "@zendeskgarden/react-loaders";
import React from "react";
import HomeOpportunities from "../../components/home/home-opportunities";
import OpportunityCard from "../../components/home/opportunity-card";
import Loading from "../../components/loading";
import { ReactComponent as Opp } from "../../images/icons/jobs.svg";
import { ReactComponent as LocationIcon } from "../../images/icons/location.svg";
import {
  HomeOpportunitiesData,
  OpportunityCardData
} from "../../model/home.model";
import {
  TERMS_OF_USE_ROUTE
} from "../../providers/routes";
import { connect } from "react-redux";
import { Location } from "../../model/location.model";
import { AuthenticationService, USER_KEY } from "../../services/auth.service";
import DictionaryService from "../../services/dictionary.service";
import OpportunityService from "../../services/opportunity.service";
import { t } from "../../translations/translation.service";
import { theme } from "../../util/colorButton";
import { getRandomMosaic } from "../../util/random-mosaic";
import { CursorPagination } from "@zendeskgarden/react-pagination";
import ReactGA from 'react-ga4';
import "./index.css";
import UserService from "../../services/user.service";
import { Modal, ModalBody, ModalFooter, ModalTitle } from "react-bootstrap";

interface IUserData {
  _id: string;
  roles: string[];
  firstName: string;
}

interface userPrivacyPolicy {
  privacyPolicyAcceptance: {
    consent: boolean;
    dateOfAcceptance: Date;
    expirationDate: Date;
  }
}

class Home extends React.Component<any> {
  state = {
    locations: [] as Location[],
    loading: false,
    searchForm: {
      keywords: "",
      location: { id: "All Places", location: "All Places" },
      homeOffice: false,
    },
    locationsName: [] as string[],
    searchResults: null as unknown, 
    pageContent: null as unknown,
    inputValue: "",
    selectedItem: "",
    matchingOptions: [] as string[],
    listHome: {
      recentPresentialOpportunities: [
        {} as OpportunityCardData,
        {} as OpportunityCardData,
      ],
      brazillianOpportunities: [
        {} as OpportunityCardData,
        {} as OpportunityCardData,
      ],
      northAmericanOpportunities: [
        {} as OpportunityCardData,
        {} as OpportunityCardData,
      ],
      europeanOpportunities: [
        {} as OpportunityCardData,
        {} as OpportunityCardData,
      ],
      recentHomeOfficeOpportunities: [
        {} as OpportunityCardData,
        {} as OpportunityCardData,
        {} as OpportunityCardData,
        {} as OpportunityCardData,
      ],
    } as HomeOpportunitiesData,
    currentPage: 1,
    resultLength: 0,
    allOppsLength: 0,
    compatiblesOppList: [],
    isModalVisible: false,
  };

  constructor(props: any) {
    super(props);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.validatePrivacyPolicy = this.validatePrivacyPolicy.bind(this);
    this.verifyAcceptanceDate = this.verifyAcceptanceDate.bind(this);
    this.handleSetPrivacyPolicy = this.handleSetPrivacyPolicy.bind(this);
  }

  private userObject = {} as IUserData;

  async componentDidMount() {
    // const { _id } = await AuthenticationService.getUser();
    // Faz a validação do consentimento do usuário com relação à Política de Privacidade
    // if (isAuthenticated()) {
    //   this.setState({
    //     loading: true
    //   })
    //   // await this.validatePrivacyPolicy(_id);
    // }

    this.userObject = JSON.parse(localStorage.getItem(USER_KEY) as string);
    try {
      const placesObj = [
        { id: "All Places", location: "All Places" },
        { id: "Novidades", location: "Novidades" },
        { id: "Home Office", location: "Home Office" },
        { id: "Brasil", location: "Brasil" },
        { id: "America do Norte", location: "America do Norte" },
      ]
      const placesNames = [
        "All Places",
        "Novidades",
        "Home Office",
        "Brasil",
        "America do Norte"
      ]
      const locations = (await DictionaryService.getStates()).data;
      const locationsName = locations.map((localName: any) => localName.location)
      locationsName.unshift(...placesNames);
      locations.unshift(...placesObj)
      this.setState({
        locations,
        locationsName: locationsName,
        matchingOptions: locationsName,
        selectedItem: locationsName[0],
      });
    } catch (error) {
      console.error(error);
    }

    const list = (await OpportunityService.getHomeOpportunities()).data;
    if (!AuthenticationService.isRh() && this.userObject) {
      const compatibleOpportunitiesList = (
        await OpportunityService.getCompatibleHomeOpportunities(this.userObject._id)
      ).data;

      this.setState({
        compatiblesOppList: compatibleOpportunitiesList.length > 0 ? compatibleOpportunitiesList : [],
      })
    }

    this.setState({
      listHome: {
        recentPresentialOpportunities: list.recentPresentialOpportunities,
        recentHomeOfficeOpportunities: list.recentHomeOfficeOpportunities,
        brazillianOpportunities: list.brazillianOpportunities,
        europeanOpportunities: list.europeanOpportunities,
        northAmericanOpportunities: list.northAmericanOpportunities,
      },
    });
  }

  async componentDidUpdate(prevProps: any, prevState: any) {
    if (prevProps.currentButton !== this.props.currentButton) {
      this.setState({ loading: true });
      let searchResults;
      const location = this.props.currentButton.searchForm.location
      if (location.location === "Oportunidades Compatíveis") {
        searchResults = (
          await OpportunityService.getCompatibleHomeOpportunities(this.userObject._id)
        ).data;
      } else {
        searchResults = (
          await OpportunityService.searchOpportunities(
            this.props.currentButton.searchForm.keywords,
            this.props.currentButton.searchForm.location
          )
        ).data;
      }
      this.setState({
        searchResults,
        loading: false,
        searchForm: { ...this.state.searchForm, location },
      }, () => {
        this.setState({
          resultLength: Math.ceil(searchResults.length / 36),
          allOppsLength: searchResults.length,
        })
        this.paginationHome()
      });
      this.reactHomeButtonClick(location.location)
    }
    if (prevState.inputValue !== this.state.inputValue) {
      this.filterMatchingOptionsRef(this.state.inputValue)
    }
  }

  filterMatchingOptionsRef(value: string) {
    const matchedOptions = this.state.locationsName.filter(
      option => option.trim().toLowerCase().indexOf(value.trim().toLowerCase()) !== -1
    );
    this.setState({
      matchingOptions: matchedOptions
    })
  }

  reactKeywordEvent(keyword: string) {
    if (AuthenticationService.isRh()) {
      ReactGA.event({
        category: "Recruitment-actions",
        action: `recrutamento palavra-chave (${keyword})`,
        label: "rh"
      })
    } else {
      ReactGA.event({
        category: "professional-action",
        action: `profissional palavra-chave (${keyword})`,
        label: "professional"
      })
    }
  }

  reactHomeButtonClick(location: string) {
    if (AuthenticationService.isRh()) {
      ReactGA.event({
        category: "Recruitment-actions",
        action: `recrutamento área clicada - (${location})`,
        label: "rh"
      })
    } else {
      ReactGA.event({
        category: "professional-action",
        action: `profissional área clicada - (${location})`,
        label: "professional"
      })
    }
  }

  handleInputChange(event: any) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    this.setState({
      searchForm: { ...this.state.searchForm, [name]: value },
    });
  }

  async handleSubmit(event: any) {
    this.setState({ loading: true });
    event.preventDefault();
    const findLocation = this.state.locations.find((key) => {
      return key.location === this.state.selectedItem
    })
    const location = this.state.searchForm.homeOffice && !findLocation?.id
      ? { id: "Home Office", ...findLocation }
      : this.state.searchForm.homeOffice ? { id: "Home Office" } : findLocation;
    const searchResults = (
      await OpportunityService.searchOpportunities(
        this.state.searchForm.keywords,
        location
      )
    ).data;
    this.setState({
      searchResults,
      loading: false,
    }, () => {
      this.setState({
        resultLength: Math.ceil(searchResults.length / 36),
        allOppsLength: searchResults.length,
      })
      this.paginationHome()
    });
    this.reactKeywordEvent(this.state.searchForm.keywords);
    this.reactHomeButtonClick("Busca de Oportunidade")
  }

  onFirst() {
    this.setState({ currentPage: 1 }, () => {
      this.paginationHome()
    });
  }

  onLast() {
    this.setState({ currentPage: this.state.resultLength }, () => {
      this.paginationHome()
    })
  }

  onNext() {
    if (this.state.currentPage < this.state.resultLength ) {
      this.setState({ currentPage: this.state.currentPage + 1 }, () => {
        this.paginationHome()
    });
    }
  }

  onPrevious() {
    if (this.state.currentPage > 1) {
      this.setState({ currentPage: this.state.currentPage - 1 }, () => {
        this.paginationHome()
    })
    }
  }

  paginationHome() {
    let contentNumber = 36;
    let arrayCopy: any = [...this.state.searchResults as OpportunityCardData[]];
    let pageContent = arrayCopy.splice((this.state.currentPage - 1) * contentNumber, contentNumber);
    this.setState({ pageContent });
  }

  async validatePrivacyPolicy(userId: string) {
    const privacyPolicy = await UserService.getPrivacyPolicy(userId);
    if(!privacyPolicy.data) {
      this.setState({
        loading: false,
        isModalVisible: true,
      })
      return;
    }
    this.verifyAcceptanceDate(privacyPolicy.data);
  };

  verifyAcceptanceDate(userPrivacyPolicy: userPrivacyPolicy) {
    const today = new Date(Date.now());
    const expirationDate = new Date (userPrivacyPolicy.privacyPolicyAcceptance.expirationDate);
    console.log(expirationDate < today);
    if ( expirationDate < today) {
      this.setState({ loading: false, isModalVisible: true });
    }
    this.setState({ loading: false });
  }

  async handleSetPrivacyPolicy() {
    const { _id } = await AuthenticationService.getUser();
    const sixMonthsInMilliseconds = 15724800000;
    const dateOfAcceptance = new Date(Date.now());
    const expirationDate = new Date(Date.now() + sixMonthsInMilliseconds);

    const data = {consent: true, dateOfAcceptance, expirationDate}

    await UserService.setPrivacyPolicy(_id, data);
  }

  render() {
    const filterlocation =  this.props.currentButton?.searchForm?.location?.location;

    return (
      <div className="container">
      {this.state.isModalVisible 
      && (
        <Modal
        show={this.state.isModalVisible}
        scrollable
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        >
          <ModalTitle
          className="mt-4 w-100 text-center"
          >
            Política de Tratamento de Dados</ModalTitle>
          <ModalBody>
            <div
              className="mt-2 ml-2 mr-2 text-justify"
            >
              <ul>
                <li>
                <h5>POLÍTICA DE PRIVACIDADE</h5>
                <p>A <strong>Elumini S.A. (Elumini)</strong> valoriza a privacidade de seus usuários e criou esta Política de Privacidade para demonstrar seu compromisso em proteger a sua privacidade e seus dados pessoais, nos termos da Lei Geral de Proteção de Dados e demais leis sobre o tema, bem como descrever de que forma sua privacidade é protegida pela <strong>Elumini</strong> ao coletar, tratar e armazenar suas informações pessoais.</p>
                </li>

                <li>
                <h5>DEFI\NIÇÕES</h5>
                <p><strong>Usuário:</strong> todas as pessoas físicas que utilizarão ou visitarão o(s) Site(s) e/ou Aplicativo(s), maiores de 18 (dezoito) anos ou emancipadas e totalmente capazes de praticar os atos da vida civil ou os absolutamente ou relativamente incapazes devidamente representados ou assistidos.<br/><br/> <strong>Dados Pessoais:</strong> significa quaisquer informações fornecidas e/ou coletadas pela <strong>Elumini</strong>, por qualquer meio, ainda que públicos, que: (I) identifiquem, ou que, quando usadas em combinação com outras informações tratadas pela <strong>Elumini</strong> identifiquem um indivíduo; ou (II) por meio das quais a identificação ou informações de contato de uma pessoa física possam ser derivadas.<br/><br/> <strong>Finalidade:</strong> o objetivo, o propósito que a <strong>Elumini</strong> deseja alcançar a partir de cada ato de tratamento das informações pessoais.<br/><br/> <strong>Necessidade:</strong> justificativa pelo qual é estritamente necessário coletar dados pessoais, para atingir a finalidade, evitando-se a coleta excessiva.<br/><br/> <strong>Bases legais:</strong> fundamentação legal que torna legítimo o tratamento de dados pessoais para uma determinada finalidade prévia por parte da <strong>Elumini</strong>.<br/><br/> <strong>Consentimento:</strong> autorização expressa e inequívoca dada pelo Usuário titular do dado pessoal para que a <strong>Elumini</strong> trate seus dados pessoais para uma finalidade previamente descrita, na qual a base legal necessária para o ato demande a autorização expressa do titular.<br/><br/> Esta política se aplica, em geral, a todos os Usuários e potenciais Usuários dos serviços oferecidos pela <strong>Elumini</strong>, incluindo Usuários dos sites ou outros meios operados pela <strong>Elumini</strong> e resume como a <strong>Elumini</strong>, como controladora dos seus Dados Pessoais, poderá tratá-los, de acordo com as bases legais aplicáveis e todas as leis de privacidade e proteção de dados em vigor.<br/><br/> Ao acessar e/ou utilizar o site da <strong>Elumini</strong>, o Usuário declara ter no mínimo 18 (dezoito) anos e ter capacidade plena e expressa para a aceitação dos termos e condições desta Política de Privacidade e do Termo de Consentimento para todos os fins de direito.<br/><br/> Caso o Usuário não se enquadre na descrição acima e/ou não concorde, ainda que em parte, com os termos e condições contidos nesta Política de Privacidade, não deverá acessar e/ou utilizar os serviços oferecidos pela <strong>Elumini</strong>, bem como os sites e serviços por ela operados.<br/><br/> </p>
                </li>

                <li>
                <h5>COLETA E USOS DE INFORMAÇŌES PESSOAIS</h5>
                <p>O Usuário está ciente de que fornece informação de forma consciente e voluntária por meio de formulários ou por meio dos sites operados pela <strong>Elumini</strong>.<br/><br/> Quando o Usuário realiza o cadastro e/ou preenche formulários oferecidos pela <strong>Elumini</strong>, determinados Dados Pessoais solicitados serão mantidos em sigilo e serão utilizadas apenas para o propósito que motivou o cadastro, conforme a seguinte tabela:</p><table className="table table-sm text"><tbody><tr><th>MOMENTO</th><th>CATEGORIA DE DADOS PESSOAIS</th><th>FINALIDADE</th><th>BASE LEGAL</th></tr><tr><td className="mr-1">Início</td><td className="mr-1">E-mail*</td><td className="mr-1">Para poder acessar conteúdos e receber dicas de contratação (Newsletter). Bem como, para manter um canal de comunicação com o usuário e organização de suas informações na busca por uma oferta de contratação.</td><td className="mr-1">Consentimento</td></tr><tr><td className="mr-1">Contato/Cadastro Inicial do Perfil</td><td className="mr-1">Nome; Local de disponibilidade de trabalho*; Telefone*; Link de Portfólio e Redes Sociais (LinkedIn, GitHub, Stack Overflow e Site Pessoal, portifólio)</td><td className="mr-1">Para que possamos ter informações mínimas e necessárias sobre você para adequar apropriadamente o seu currículo para encaminhá-lo para as empresas em potencial e garantir a congruência do seu perfil na plataforma.</td><td className="mr-1">Consentimento</td></tr><tr><td className="mr-1">Contato/Cadastro Inicial do Perfil</td><td className="mr-1">Informação se usuário é PcD (Pessoa com Deficiência) e seu sexo.</td><td className="mr-1">Para que potenciais empresas empregadoras encaixem requisitos de vagas às suas quotas, os termos da CLT (Consolidação das Leis do Trabalho - Decreto-Lei n. 5.452/43) e da Lei n. 8.231/91.</td><td className="mr-1">Consentimento</td></tr><tr><td className="mr-1">Contato/Cadastro Inicial do Perfil</td><td className="mr-1">Foto de Perfil</td><td className="mr-1">Para melhor ranqueamento do seu currículo no processo de seleção e recrutamento para as empresas em potencial.</td><td className="mr-1">Consentimento</td></tr><tr><td className="mr-1">Área de Atuação, Experiências e Educação</td><td className="mr-1">Último e/ou Atual Salário*; Pretensão Salarial; Cargo; Onde trabalha e/ou trabalhou; Nível de Educação; Certificados; Tecnologias que conhece; Linguagens de conhecimento.</td><td className="mr-1">Para montagem do seu currículo e, consequentemente, para melhor ranqueamento do seu currículo no processo de seleção e recrutamento para as empresas em potencial.</td><td className="mr-1">Consentimento</td></tr><tr><td className="mr-1">Informações de Acesso</td><td className="mr-1">Endereço de IP, Cookies....</td><td className="mr-1">Para otimização das funcionalidades do nosso site, bem como da busca de vagas ao usuário de acordo com a região em que se encontra.</td><td className="mr-1">Legítimo interesse</td></tr></tbody></table><p></p>
                </li>

                <li>
                <h5>COMPARTILHAMENTO E TRATAMENTO DE INFORMAÇŌES PESSOAIS</h5>
                <p>A <strong>Elumini</strong> poderá divulgar os Dados Pessoais coletados a terceiros, nas seguintes situações e nos limites exigidos e autorizados pela Lei:<br/> </p><ol> <li>Com os seus clientes e parceiros quando necessário e/ou apropriado à prestação de serviços relacionados, sobretudo os relacionados ao recrutamento e seleção;</li> <li>Com as empresas e indivíduos contratados para a execução de determinadas atividades e serviços em nome da <strong>Elumini</strong>;</li> <li>Com empresas do grupo;</li> <li>Com fornecedores e parceiros para consecução dos serviços contratados com a <strong>Elumini</strong> (como tecnologia da informação, contabilidade, entre outros);</li> <li>Para propósitos administrativos como: pesquisa, planejamento, desenvolvimento de serviços, segurança e gerenciamento de risco.</li> <li>Quando necessário em decorrência de obrigação legal, determinação de autoridade competente, ou decisão judicial.</li> </ol> <br/> <p> Atualmente, para melhor execução dos serviços da <strong>Elumini</strong>, os seus Dados Pessoais são compartilhados com as seguintes operadoras: </p> <table className="table table-sm"><tbody><tr><th>Operador</th><th>Finalidade</th><th>Consulte a Política de Privacidade</th></tr><tr><td className="mr-1">Google Analytics</td><td className="mr-1">Ferramenta de monitoramento utilizada para entendermos melhor quem tem nos visitado e, assim, melhorar nossos serviços.</td><td className="mr-1">https://support.google.com/analytics/answer/4597324?hl=pt-BR</td></tr><tr><td className="mr-1">Filestack</td><td className="mr-1">Ferramenta de upload de documentos</td><td className="mr-1">https://www.ideracorp.com/Legal/PrivacyShield</td></tr></tbody></table> <br/> <p> Nas hipóteses de compartilhamento de Dados Pessoais com terceiros, todos os sujeitos mencionados nos itens I a VI deverão utilizar os Dados Pessoais partilhados de maneira consistente e de acordo com os propósitos para os quais foram coletados (ou com os quais o Usuário consentiu previamente) e de acordo com o que foi determinado por esta Política de Privacidade, outras declarações de privacidade de website ou países, e todas as leis de privacidade e proteção de dados aplicáveis.<br/><br/> Quando a empresa recrutadora, cliente da <strong>Elumini</strong>, for uma instituição financeira ou uma seguradora, de acordo normas legais e regulamentações do Banco Central do Brasil e da Susep - Superintendência de Seguros Privados, seus dados poderão ser consultados para uma possível análise relacionada à práticas ilícitas tais como lavagem de dinheiro e terrorismo (Circular nº 3978 do BACEN e Circular nº 612/2020 da SUSEP). </p> <p></p>
                </li>

                <li>
                <h5>MOTIVOS LEGAIS PARA A DIVULGAÇÃO DE SEUS DADOS</h5>
                <p>Em certas circunstâncias, a <strong>Elumini</strong> poderá divulgar Dados Pessoais, na medida necessária ou apropriada, para órgãos governamentais, consultores e outros terceiros com o objetivo de cumprir com a legislação aplicável ou com uma ordem ou intimação judicial ou, ainda, se a <strong>Elumini</strong> acreditar de boa-fé que tal ação seja necessária para:<br/> </p><ol> <li>Cumprir com uma legislação que exija tal divulgação;</li> <li>Investigar, impedir ou tomar medidas relacionadas a atividades ilegais suspeitas ou reais ou para cooperar com órgãos públicos ou para proteger a segurança nacional;</li> <li>Execução de seus contratos;</li> <li>Investigar e se defender contra quaisquer reivindicações ou alegações de terceiros;</li> <li>Proteger a segurança ou a integridade dos serviços (por exemplo, o compartilhamento com empresas que estão sofrendo ameaças semelhantes);</li> <li>Exercer ou proteger os direitos, a propriedade e a segurança da <strong>Elumini</strong> e suas empresas coligadas;</li> <li>Proteger os direitos e a segurança pessoal de seus funcionários, usuários ou do público;</li> <li>Em caso de venda, compra, fusão, reorganização, liquidação ou dissolução da <strong>Elumini</strong>.</li> </ol> <br/> <p>A <strong>Elumini</strong> poderá contestar essas demandas se julgar que as solicitações são excessivas, vagas ou feitas por autoridades incompetentes.</p> <p></p>
                </li>

                <li>
                <h5>SEGURANÇA DE INFORMAÇŌES PESSOAIS</h5>
                <p>Todos os Dados Pessoais serão guardados na base de dados da <strong>Elumini</strong> ou em base de dados mantidas “na nuvem” pelos fornecedores de serviços contratados pela <strong>Elumini</strong>, os quais estão devidamente de acordo com a legislação de proteção de dados vigente.<br/><br/> A <strong>Elumini</strong> e seus fornecedores utilizam diversos procedimentos de segurança para proteger a confidencialidade, segurança e integridade de seus Dados Pessoais, prevenindo a ocorrência de eventuais danos em virtude do tratamento desses dados.<br/><br/> Embora a <strong>Elumini</strong> utilize medidas de segurança e monitore seu sistema para verificar vulnerabilidades e ataques para proteger seus Dados Pessoais contra divulgação não autorizada, mau uso ou alteração, o Usuário entende e concorda que não há garantias de que as informações não poderão ser acessadas, divulgadas, alteradas ou destruídas por violação de qualquer uma das proteções físicas, técnicas ou administrativas. </p>
                </li>

                <li>
                <h5>RETENÇÃO DE DADOS</h5>
                <p>A <strong>Elumini</strong> retém todos os dados fornecidos, inclusive os Dados Pessoais, enquanto o cadastro do Usuário estiver ativo e conforme seja necessário para consecução de seus serviços.<br/><br/> A <strong>Elumini</strong> reterá seus Dados Pessoais e manterá seus dados armazenados até eventual requerimento de exclusão, ou de acordo com os períodos descritos neste documento.<br/><br/> A <strong>Elumini</strong> poderá vir a manter seus Dados Pessoais após receber seu pedido de exclusão ou após os prazos deste documento caso seja necessário para cumprimento de obrigações legais, resolver disputas, manter a segurança, evitar fraudes e abuso e garantir o cumprimento de contratos.<br/><br/> É importante ressaltar que, nos casos de contratação, a empresa que recrutou o candidato esta assumirá o papel de <strong>controladora</strong> dos dados pessoais e, dessa forma, manterá os dados armazenados pelo período que julgar necessário, de acordo com seus próprios critérios internos e legais.<br/><br/> Dessa forma, como se trata de uma outra relação de tratamento, a <strong>Elumini</strong> não possui gestão sobre tal questão. </p>
                </li>

                <li>
                <h5>BASES LEGAIS PARA PROCESSAMENTO</h5>
                <p>A <strong>Elumini</strong> apenas trata Dados Pessoais em situações em que está autorizada legalmente ou mediante seu expresso e inequívoco consentimento do Usuário.
                <br/><br/> Conforme descrito na presente Política, a <strong>Elumini</strong> tem bases legais para coletar, produzir, receptar, classificar, utilizar, acessar, reproduzir, transmitir, distribuir, processar, arquivar, armazenar, eliminar, avaliar ou controlar a informação, modificar, comunicar, transferir, difundir ou extrair dados sobre o Usuário.<br/><br/> As bases legais incluem seu consentimento (colhido de forma expressa e inequívoca em nossa Plataforma), contratos e procedimentos preliminares contratuais (em que o processamento é necessário para firmar o contrato com o Usuário) e interesses legítimos, desde que tal processamento não viole seus direitos e liberdades, conforme se pode verificar neste documento.<br/><br/> Tais interesses incluem proteger o Usuário e a <strong>Elumini</strong> de ameaças, cumprir a legislação aplicável, o exercício regular de direitos em processo judicial, administrativo ou arbitral, habilitar a realização ou administração dos negócios, incluindo controle de qualidade, relatórios e serviços oferecidos, gerenciar transações empresariais, entender e melhorar os negócios e relacionamentos com os clientes e permitir que os usuários encontrem oportunidades econômicas.<br/><br/> O Usuário tem o direito de negar ou retirar o consentimento fornecido à <strong>Elumini</strong>, quando esta for a base legal para tratamento dos dados pessoais, podendo a <strong>Elumini</strong> encerrar a consecução de seus serviços para este usuário na hipótese de ocorrência de tal solicitação, observando-se, contudo, que, em eventuais casos, os clientes da <strong>Elumini</strong>, por conta da contratação, ou de procedimentos preliminares à contratação, assumirão o papel de controlador dos dados pessoais, devendo o titular, neste caso, requisitar diretamente a este a exclusão dos dados.<br/><br/> Caso tenha dúvidas sobre as bases legais para coleta, tratamento e armazenamento de seus dados pessoais, entre em contato com a <strong>Elumini</strong> e seu <i>Data Protection Officer</i> por meio do e-mail <u>dpo@elumini.com.br</u>. </p>
                </li>

                <li>
                <h5>DIREITO DE ACESSAR E CONTROLAR SEUS DADOS PESSOAIS</h5>
                <p>A <strong>Elumini</strong> oferece ao Usuário diversas opções do que fazer com seus Dados Pessoais coletados, tratados e armazenados, incluindo sua exclusão e/ou correção. O Usuário pode:<br/> </p> <ol> <li><strong>Excluir dados:</strong> o Usuário pode solicitar a exclusão de alguns dos seus Dados Pessoais (por exemplo, se eles não são mais necessários para lhe fornecer os serviços).</li> <li><strong>Alterar ou corrigir dados:</strong> o Usuário pode editar ou solicitar a edição de alguns dos seus Dados Pessoais. O Usuário também pode solicitar atualizações, alterações ou correções de seus dados em determinados casos, principalmente se eles estiverem incorretos.</li> <li><strong>Colocar objeções, limites ou restrições ao uso de dados:</strong> o Usuário pode solicitar a interrupção do uso de todos ou alguns de seus Dados Pessoais (por exemplo, se não tivermos o direito de continuar a usá-los), ou limitar a nossa utilização de tais dados (por exemplo, se seus Dados Pessoais estiverem incorretos ou armazenados ilegalmente), destacando-se que a Elumini poderá tratar os Dados Pessoais de acordo com as bases legais listadas neste documento.</li> <li><strong>O Usuário tem direito de acessar ou levar seus dados:</strong> o Usuário pode solicitar uma cópia dos seus Dados Pessoais e dos dados que o Usuário forneceu em um formato legível sob a forma impressa ou por meio eletrônico.</li> </ol> <br/> <p>O Usuário pode fazer as solicitações listadas acima entrando em contato com o nosso <i>Data Protection Officer</i> por meio do e-mail <u>dpo@elumini.com.br</u> e estes pedidos serão considerados de acordo com as leis aplicáveis.</p> <p></p>
                </li>

                <li>
                <h5>REVISŌES À POLÍTICA</h5>
                <p>Caso a <strong>Elumini</strong> modifique esta Política de Privacidade, tais alterações serão publicadas de forma visível no site da <strong>Elumini</strong>. Esta Política é válida a partir de 17/01/2023. Caso o Usuário tenha quaisquer questões a respeito das políticas de privacidade do website, por favor, entre em contato com a <strong>Elumini</strong>, por meio dos endereços abaixo/canal de atendimento do <i>Data Protection Officer</i>.</p>
                </li>

                <li>
                <h5>TRANSFERÊNCIA INTERNACIONAL</h5>
                <p>Atualmente, utilizamos a cloud da AWS (<i>Amazon Web Services</i>), localizada nos Estados Unidos da América (EUA).<br/><br/> Dessa forma, os dados inseridos pelos usuários em nossa Plataforma serão lá armazenados, ocorrendo, assim, a transferência internacional, nos termos da LGPD.<br/><br/> Neste contexto, adotaremos todas as medidas aplicáveis (técnicas, organizacionais e jurídicas) para garantir a conformidade e segurança dos dados armazenados, estando à disposição para sanar qualquer dúvida através de nosso DPO (<u>dpo@elumini.com.br</u>).<br/><br/> Importante também salientar que os dados pessoais fornecidos pelo usuário também sofrer a transferência internacional em virtude das empresas que compartilhamos os dados para prestação de serviços, conforme indicado no tópico “COLETA E USOS DE INFORMAÇŌES PESSOAIS”. </p>
                </li>

                <li>
                <h5>ENTRE EM CONTATO</h5>
                <p>O Usuário pode entrar em contato com o DPO através do e-mail <u>dpo@elumini.com.br</u>.</p>
                </li>

                </ul>
            </div>
          </ModalBody>
          <form>
            <ModalFooter>
              <button
                type="submit"
                className="btn-enviar w-100 mt-2 button-entrar"
                onClick={() => this.handleSetPrivacyPolicy()}
              >
              Aceitar a Política e Entrar
              </button>
              <button
                className="btn-enviar w-100 mt-2 button-entrar"
                onClick={() => this.props.history.push('/')}
              >
                Rejeitar a Política
              </button>
              <p className="text-center u-fs-md u-fg-grey-500 mt-2 mx-2">
                {t("Ao clicar em Aceitar e cadastrar, você aceita os ")}
                <a
                  href={TERMS_OF_USE_ROUTE}
                  className="u-semibold u-fg-grey-500"
                >
                  {t("Termos de Uso do Enter.")}
                </a>
              </p>
            </ModalFooter>
          </form>
        </Modal>
          )}
       <h3 className="video-title">
          <span className="video-main-title">{t("Saiba mais sobre o Enter")}</span>
          <br />
          <span className="video-subtitle">
            {t("Ele pode transformar suas oportunidades e abrir novas portas para o seu futuro. Confira o vídeo!")}
          </span>
        </h3>

        <div className="video-container">
          <iframe 
            width="100%" 
            height="500" 
            src="https://www.youtube.com/embed/coTkav6F4dA" 
            title="Vídeo de Apresentação"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>


        <form onSubmit={this.handleSubmit}>
          <Row className="opp-filter-home">
            <Col sm={12} lg={6}>
              <Field className="input-search">
                <MediaInput
                  placeholder={t("Oportunidade")}
                  start={<Opp style={{ width: 23, height: 23 }} />}
                  value={this.state.searchForm.keywords}
                  name="keywords"
                  onChange={this.handleInputChange}
                />
              </Field>
            </Col>
            <Col sm={12} lg={4}>
              <Dropdown
                selectedItem={this.state.selectedItem}
                inputValue={this.state.inputValue}
                onInputValueChange={(value) =>
                  this.setState({
                    inputValue: value
                  })}
                onSelect={(value) =>
                  this.setState({
                    selectedItem: value
                  })
                }
                downshiftProps={{ defaultHighlightedIndex: 0 }}
              >
                <FieldDrop className="input-search">
                  <Autocomplete
                    start={<LocationIcon style={{ width: 23, height: 23 }} />}
                  >
                    {t(this.state.selectedItem)}
                  </Autocomplete>
                </FieldDrop>
                <Menu>
                {this.state.matchingOptions.length ? (
                    this.state.matchingOptions.map(option => (
                      <Item key={option} value={option}>
                        <span>{option}</span>
                      </Item>
                    ))
                  ) : (
                    <Item disabled>{t("Nenhum resultado encontrado")}</Item>
                  )}
                </Menu>
              </Dropdown>
              {/* </Field> */}
              <div className="text-right">
                <ThemeProvider theme={theme as any}>
                  <ToggleField>
                    <Toggle name="homeOffice" onChange={this.handleInputChange}>
                      <Label className="home-office">{`Home Office / ${t(
                        "Híbrida"
                      )}`}</Label>
                    </Toggle>
                  </ToggleField>
                </ThemeProvider>
              </div>
            </Col>
            <Col sm={12} lg={2}>
              <button type="submit" className="w-100 find-button">
                {t("Encontrar")}
              </button>
            </Col>
          </Row>
        </form>
        {this.state.searchResults && (
          <div>
            <div className="d-flex justify-content-between">
              <h4 className="section-home-title pl-2">
                #{this.state.selectedItem !== "All Places" ? this.state.selectedItem : t(filterlocation)}
              </h4>
              <button
                className="back-button-home pl-2"
                onClick={() => {
                  const searchForm = {
                    keywords: "",
                    location: { id: "All Places", location: "All Places" },
                    homeOffice: false,
                  }
                  this.setState(
                    {
                      searchResults: null as unknown,
                      searchForm,
                      selectedItem: "",
                      currentPage: 1
                    }, () => {
                      this.setState({ selectedItem: searchForm.location.location})
                    }
                  )
                }}
              >
                {t("Voltar")}
              </button>
            </div> 
            <div>
              <Row>
                <Col sm={6}>
                  <span
                    className="opp-found ml-4"
                  >
                    {`${this.state.allOppsLength} ${t("oportunidades encontradas")}`}
                  </span>
                </Col>
                <Col sm={6}>
                  <CursorPagination
                    style={{
                      justifyContent: "end",
                      fontSize: "0.75rem",
                    }}
                    aria-label="Cursor pagination"
                  >
                    <CursorPagination.First
                      onClick={this.onFirst.bind(this)}
                      disabled={this.state.currentPage === 1}
                    />
                    <CursorPagination.Previous
                      onClick={this.onPrevious.bind(this)}
                      disabled={this.state.currentPage === 1}
                    />
                    <span className="pagination-number">
                      {this.state.currentPage}
                    </span>
                    <CursorPagination.Next
                      onClick={this.onNext.bind(this)}
                      disabled={this.state.currentPage === this.state.resultLength}
                    />
                    <CursorPagination.Last
                      onClick={this.onLast.bind(this)}
                      disabled={this.state.currentPage === this.state.resultLength}
                    />
                    <span className="pagination-number-last">
                      {("de " + this.state.resultLength)}
                    </span>
                  </CursorPagination>
                </Col>
              </Row>
            </div>        
            <div className="row">
              {(this.state.searchResults as OpportunityCardData[])?.length > 0 ? (
                (this.state.pageContent as OpportunityCardData[])?.map(
                  (opp, index) => (
                    <div key={index + "¨¬"} className="col-12 col-sm-6 col-md-4">
                      <OpportunityCard
                        id={opp.id}
                        index={0}
                        key={index}
                        img={getRandomMosaic(opp.title)}
                        title={opp.title}
                        locations={opp.location}
                        geolocation={opp.geolocation}
                        homeOffice={opp.homeOffice}
                        hybrid={opp.hybrid}
                        isCandidate={opp.isCandidate}
                        isEnrolled={opp.isEnrolled}
                        isHotOpportunity={opp.isCompatibleCandidate}
                        isHotOpportunityLevel={opp.isCompatibleCandidateLevel}
                      />
                    </div>
                  )
                )
              ) : (
                <h1 className="text-center">{t("Nenhuma oportunidade encontrada")}.</h1>
              )}
            </div>
          </div>
        )}
        {!this.state.searchResults && (
          <HomeOpportunities
            key="HomeOpportunities"
            listHome={this.state.listHome}
            listCompatibleOppHome={this.state.compatiblesOppList}
            userId={this.userObject?._id}
          ></HomeOpportunities>
        )}
      </div>
    );
  } 
 
}

const mapStateToProps = (store: {
  opportunityFilterReducer: { currentButton: any }
}) => ({
  currentButton: store.opportunityFilterReducer.currentButton,
})

export default connect(mapStateToProps, null)(Home)
